export default {
  serviceMenuOverview: "개요",
  serviceMenuPipeline: "파이프라인",
  serviceMenuAnalytics: "분석",
  serviceMenuResources: "리소스",
  salesServices: "영업 서비스",
  chooseYourTypeofServicesToStreamlineAndEnhanceYourBusinessOperations:
    "비즈니스 운영을 간소화하고 강화하기 위해 원하는 서비스 유형을 선택하세요",
  dataPreparation: "데이터 준비",
  salesAssistant: "영업 지원",
  appointmentSetting: "약속 설정",
  othersCustomService: "기타 (맞춤 서비스)",
  requestService: "서비스 요청",
  learnMore: "더 알아보기",
  serviceRequestStatus: "서비스 요청 상태",
  noServiceRequestsYet: "아직 서비스 요청이 없습니다",
  submitYourFirstRequestToUnlockThePower:
    "첫 번째 요청을 제출하여 영업 서비스의 힘을 느껴보세요! 여기에서 요청 상태를 추적하여 영업 활동을 강화하세요. 지금 시작해 보세요!",
  serviceTableItemName: "이름",
  serviceTableItemStatus: "상태",
  serviceTableItemType: "유형",
  serviceTableItemProgress: "진행률",
  serviceTableItemStart: "시작",
  serviceTableItemEnd: "종료",
  serviceTableItemPriority: "우선순위",
  addASubject: "제목 추가",
  created: "생성됨",
  closed: "종료됨",
  paused: "일시 중지됨",
  working: "진행 중",
  completed: "완료됨",
  resuming: "재개 중",
  reviewing: "검토 중",
  others: "기타",
  data_preparation: "데이터 준비",
  sales_assistant: "영업 지원",
  appointment_setting: "약속 설정",
  appointment_booking: "약속 예약",
  low: "낮음",
  normal: "보통",
  urgent: "긴급",
  high: "높음",
  requiredCredits: "필요 크레딧",
  serviceCreated: "생성됨",
  QandARecord: "Q&A 기록",
  serviceAttachments: "첨부 파일",
  discussionBoard: "토론 게시판",
  wannaAddSomething: "추가할 내용이 있나요?",
  serviceEdit: "수정",
  serviceDelete: "삭제",
  addDescription: "설명 추가",
  DragDropor: "드래그 & 드롭 또는",
  chooseFile: "파일 선택",
  toUpload: "업로드하기",
  ourDataPreparationService:
    "데이터 준비 서비스는 영업 데이터 관리를 최적화하기 위한 포괄적인 솔루션을 제공합니다. 이 서비스는 기존 데이터 세트를 개선하고, 데이터 정제를 통해 정확성을 확보하며, 고객의 요구에 완벽하게 맞는 맞춤형 목록을 생성하는 데 중점을 둡니다. 이 접근 방식을 통해 데이터를 효과적으로 관리하는 데 필요한 유연성과 효율성을 얻을 수 있습니다.",
  moreoverWithOurDedicatedDataManagement:
    "또한, 전용 데이터 관리 서비스인 Pubrio를 사용하면 프로세스가 더욱 쉬워집니다. 파일을 원활하게 첨부하고 추가 정보로 데이터 세트를 보강할 수 있습니다. Pubrio는 데이터 보강뿐만 아니라 특정 기준에 따라 완전히 새로운 목록을 생성할 수도 있습니다. 이 맞춤형 서비스를 통해 데이터 세트가 고객의 목표와 산업 표준에 정확하게 맞춤화되므로 데이터 환경을 자유롭게 제어할 수 있습니다.",
  flexibilityToAttach:
    "기존 목록을 첨부하거나 지정된 기준에 따라 Pubrio가 새로운 목록을 찾도록 요청할 수 있는 유연성.",
  comprehensiveDataEnrichment:
    "누락된 세부 정보를 추가하고 데이터 세트의 완전성을 향상시키는 포괄적인 데이터 보강.",
  dataCleansingServicesToEnsureAccuracy:
    "중복 제거 및 오류 수정 등 정확성과 품질을 보장하는 데이터 정제 서비스.",
  abilityToInstructPubrio:
    "정교하게 정의된 기준에 따라 Pubrio가 완전히 새로운 목록을 큐레이션하도록 지시하는 기능.",
  tailoringDatasetsPrecisely:
    "특정 목표 및 산업 표준에 정확하게 맞게 데이터 세트를 맞춤화.",
  dataEnrichmentWithExistingList:
    "기존 목록으로 데이터 보강: Pubrio에 기존 목록을 업로드하여 쉽게 보강하세요. 이메일 주소 및 전화번호와 같이 누락된 세부 정보를 고객의 요구 사항에 맞게 채워드립니다. 예를 들어, 고객 데이터베이스를 제공하면 필수 정보로 업데이트해 드립니다.",
  customListGenerationIf:
    "맞춤 목록 생성: 목록이 없는 경우, Pubrio가 대신 찾아드립니다. 직책이나 산업과 같은 기준만 알려주시면 완벽한 목록을 만들어 드립니다. 예를 들어, 특정 지역의 최고 기술 경영진 목록이 필요한 경우, 저희가 처리해 드립니다.",
  dataCleansingForExistingLists:
    "기존 목록 데이터 정제: Pubrio의 데이터 정제 서비스로 데이터의 정확성과 신뢰성을 보장하세요. 목록을 보내주시면 중복을 제거하고 오류를 수정해 드립니다. 예를 들어, 최근 리드 목록이 있는 경우 마케팅 캠페인에 사용할 수 있도록 준비해 드립니다.",
  empoweringYourSalesEeavors:
    "영업 활동을 강화하기 위해, 영업 지원 서비스는 다양한 핵심 영역에 대한 포괄적인 지원을 제공하여, 고객의 아웃리치 및 커뮤니케이션 전략이 성공을 위해 완벽하게 조정되도록 합니다. 매력적인 콘텐츠를 제작하거나, 이벤트를 원활하게 조직하거나, 맞춤형 프레젠테이션을 개발하거나, 영업 및 커뮤니케이션 전략을 개선하려는 경우, 당사의 전담 팀이 고객의 영업 노력을 강화하고 시장에서 브랜드의 입지를 높일 수 있도록 도와드립니다.",
  craftingCompellingContent:
    "매력적인 콘텐츠 제작: 효과적인 커뮤니케이션은 고객의 관심을 사로잡는 핵심입니다. 당사의 팀은 고객의 브랜드 및 고객 선호도에 맞춘 매력적인 콘텐츠 제작에 탁월합니다. 생각을 자극하는 LinkedIn 게시물부터 유익한 블로그 기사, 눈길을 사로잡는 소셜 미디어 업데이트까지, 고객의 메시지가 타겟 시장에 울려 퍼지도록 합니다.",
  seamlessEventAndWebinarPreparation:
    "원활한 이벤트 및 웨비나 준비: 이벤트 및 웨비나는 고객과 소통하고 리드를 창출하기 위한 강력한 도구입니다. 영업 지원 서비스는 계획 및 홍보부터 실행까지 모든 세부 사항을 처리합니다. 유익한 웨비나를 주최하든 네트워킹 이벤트를 조직하든, 고객의 이벤트가 지속적인 인상을 남기도록 보장합니다.",
  tailoredContentDevelopmentAndPresentation:
    "맞춤형 콘텐츠 개발 및 프레젠테이션: 매력적인 프레젠테이션과 개인화된 메시지로 고객을 사로잡으세요. 당사의 팀은 시각적으로 매력적인 자료를 만들고 특정 고객층에 맞는 맞춤형 메시지를 작성하는 데 특화되어 있습니다. 투자자에게 피칭하거나 리드를 육성하든, 고객의 콘텐츠가 돋보이도록 보장합니다.",
  strategicSalesAndCommunicationFrameworks:
    "전략적 영업 및 커뮤니케이션 프레임워크: 전략적 지침과 효과적인 커뮤니케이션 스크립트로 영업 프로세스를 간소화하세요. 영업 지원 서비스는 전환을 유도하고 의미 있는 관계를 육성하는 데 필요한 도구와 전략을 팀에 제공합니다.",
  craftingCompellingContent: "매력적인 콘텐츠 제작",
  companyLinkedInPosts: "회사 LinkedIn 게시물 (빈도: 주간 또는 월간)",
  personalLinkedInPosts:
    "개인 LinkedIn 게시물 (빈도: 유연, 선호도 및 콘텐츠 가용성에 따라)",
  websiteBlogPosts:
    "웹사이트 블로그 게시물 (빈도: 일반적으로 주간 또는 격주)",
  socialMediaPosts:
    "소셜 미디어 게시물 (빈도: 매일 또는 콘텐츠 전략에 따라)",
  emailMarketingCampaigns:
    "이메일 마케팅 캠페인 (빈도: 주간 또는 격주)",
  seamlessEventAndWebinarPreparation: "원활한 이벤트 및 웨비나 준비",
  webinarAndWorkshopPreparation: "웨비나 및 워크숍 준비",
  networkingAndOfflineEvent: "네트워킹 및 오프라인 이벤트 조정",
  tailoredContentDevelopment: "맞춤형 콘텐츠 개발 및 프레젠테이션",
  companyDeckPreparation:
    "회사 자료 준비 (프레젠테이션, 피칭 등용)",
  highlyPersonalizedMessage:
    "고도로 개인화된 메시지 생성 (특정 고객층에 맞춤형)",
  strategicSales: "전략적 영업 및 커뮤니케이션 프레임워크",
  salesCallScripts: "영업 전화 스크립트",
  emailOutreachTemplate: "이메일 아웃리치 템플릿",
  salesChannelStrategies: "영업 채널 전략",
  ourAppointmentSettingService:
    "약속 설정 서비스는 중요한 연결을 촉진하고, 산업 노출을 육성하며, 가치 있는 잠재 고객을 양성함으로써 고객의 비즈니스를 향상시키기 위해 맞춤화되었습니다. 당사는 개별 산업 노출, 원활한 세미나 및 웨비나 조정, 신규 잠재 고객 워밍업, 새로운 고객에 대한 매력적인 접근 방식 시작을 전문으로 합니다.",
  individualIndustryAppointment:
    "개별 산업 약속 노출 및 반응",
  tailoredOutreach:
    "업계 내 주요 의사 결정자 및 영향력 있는 사람들에게 맞춤형 아웃리치를 통해 타겟팅된 노출을 보장합니다.",
  strategicFollowups:
    "전략적 후속 조치를 통해 반응을 측정하고, 우려 사항을 해결하며, 더 깊은 관계를 육성할 수 있습니다.",
  eachInteraction:
    "각 상호 작용은 수신자의 프로필 및 선호도에 따라 개인화되어 영향을 극대화합니다.",
  seminarWebinarCoordination: "세미나 및 웨비나 조정",
  ourExpertTeamHandles:
    "당사의 전문가 팀은 초기 계획부터 이벤트 후속 조치까지 세미나 및 웨비나 조정의 모든 측면을 처리합니다.",
  weMeticulouslyPlan:
    "고객의 전문성을 보여주기 위해 이벤트를 세심하게 계획하고 실행하여 참가자에게 원활하고 매력적인 경험을 보장합니다.",
  byLeveragingAdvancedTechnologyPlatforms:
    "고급 기술 플랫폼을 활용하여 상호 작용 및 참여를 강화하고 이벤트의 영향을 극대화합니다.",
  newProspectWarmUp: "신규 잠재 고객 워밍업",
  proactiveEngagementStrategies:
    "신규 잠재 고객을 워밍업하기 위한 사전 예방적 참여 전략이 채택되어, 유익한 논의를 위한 토대를 마련합니다.",
  tailoredCommunicationStrategies:
    "고객의 제안에 대한 관계, 신뢰 및 관심을 구축하기 위해 맞춤형 커뮤니케이션 전략이 배포됩니다.",
  throughStrategicNurturing:
    "전략적 육성을 통해 잠재 고객의 참여를 유지하고 전환을 준비시켜 성공적인 약속 가능성을 높입니다.",
  newAudienceApproach: "새로운 고객층 접근",
  weEmployInnovativeStrategies:
    "전통적인 채널을 넘어 새로운 고객에게 도달하고 비즈니스의 범위를 확장하기 위해 혁신적인 전략을 채택합니다.",
  targetedOutreachCampaigns:
    "철저한 고객 조사 및 세분화를 기반으로 타겟팅된 아웃리치 캠페인을 제작하여 관련성 및 효과를 보장합니다.",
  ourApproachIsContinuouslyOptimized:
    "당사의 접근 방식은 피드백 및 통찰력을 기반으로 지속적으로 최적화되어 새로운 고객에게 도달하고 참여시키는 데 앞서 나갈 수 있도록 합니다.",
  individualIndustry: "개별 산업 약속 노출 및 반응",
  personalizedAppointmentSetting:
    "업계 이해 관계자와의 개인화된 약속 설정.",
  strategicFollowupCommunication:
    "추가 참여를 위한 전략적 후속 커뮤니케이션.",
  comprehensivePlanning: "이벤트의 포괄적인 계획 및 실행.",
  utilizationOfAdvancedTechnologies:
    "향상된 상호 작용을 위한 고급 기술 활용.",
  newProspectWarmUp: "신규 잠재 고객 워밍업",
  proactiveEngagementStrategy:
    "잠재 고객에 맞춘 사전 예방적 참여 전략.",
  customizedCommunication: "관심을 유지하기 위한 맞춤형 커뮤니케이션.",
  newAudienceApproach: "새로운 고객층 접근",
  innovativeOutreach:
    "새로운 고객을 위해 설계된 혁신적인 아웃리치 캠페인.",
  continuousRefinement: "피드백 및 통찰력을 기반으로 한 지속적인 개선.",
  customService: "맞춤 서비스",
  tailoredToMeet:
    "고객의 고유한 요구를 충족하도록 맞춤화된 맞춤 서비스는 광범위한 요구 사항을 해결하기 위한 유연성과 적응성을 제공합니다. 웨비나 참가자 추적, 오프라인 이벤트 홍보, 광고 강화 또는 기타 전문적인 작업에 대한 지원이 필요한 경우, 당사의 전담 팀이 고객의 목표를 효율적이고 효과적으로 달성할 수 있도록 도와드립니다.",
  webinarParticipantsTracking: "웨비나 참가자 추적",
  comprehensiveTrackingOfWebinar:
    "참여 수준을 분석하고 가치 있는 통찰력을 수집하기 위한 웨비나 참가자에 대한 포괄적인 추적.",
  customizedReportsAndAnalytics:
    "웨비나의 효과를 평가하고 향후 전략을 최적화하기 위한 맞춤형 보고서 및 분석.",
  seamlessIntegration:
    "간소화된 데이터 관리 및 보고를 위한 기존 시스템과의 원활한 통합.",
  offlineEventPromotion: "오프라인 이벤트 홍보",
  strategicPlanning:
    "참여도 및 참여율을 극대화하기 위한 오프라인 이벤트 홍보 캠페인의 전략적 계획 및 실행.",
  utilizationOfTargetedMarketingChannels:
    "원하는 고객에게 효과적으로 도달하기 위한 타겟팅된 마케팅 채널 및 프로모션 전술 활용.",
  creativeApproaches:
    "각 이벤트의 고유한 특성에 맞춰 최대의 영향과 ROI를 보장하는 창의적인 접근 방식.",
  adsEnhancement: "광고 강화",
  optimizationOfAdCampaigns:
    "가시성, 참여도 및 전환율을 높이기 위해 다양한 플랫폼에서 광고 캠페인 최적화.",
  ABTesting:
    "가장 효과적인 광고 크리에이티브, 메시징 및 타겟팅 전략을 식별하기 위한 A/B 테스트 및 성능 분석.",
  continuousMonitoring:
    "변화하는 시장 역학에 적응하고 결과를 극대화하기 위한 광고 캠페인의 지속적인 모니터링 및 조정.",
  customizedSolutions: "맞춤형 솔루션",
  ourCustomService:
    "맞춤 서비스는 미리 정의된 기능을 넘어 고객의 특정 요구 사항 및 선호도를 충족합니다.",
  whetherYouNeedAssistance:
    "데이터 분석, 콘텐츠 제작, 전략적 계획 또는 비즈니스의 다른 측면에 대한 지원이 필요한 경우, 고객의 요구에 맞게 서비스를 맞춤화할 수 있습니다.",
  ourFlexibleApproach:
    "당사의 유연한 접근 방식을 통해 고객과 긴밀하게 협력하여 가시적인 결과를 제공하고 비즈니스 성장을 주도하는 맞춤형 솔루션을 개발할 수 있습니다.",
  setupAndImplementation:
    "웨비나 참가자 추적 시스템 설정 및 구현.",
  customizedReporting:
    "웨비나 성과 및 고객 참여를 측정하기 위한 맞춤형 보고 및 분석.",
  developmentAndExecution:
    "타겟팅된 오프라인 이벤트 홍보 캠페인 개발 및 실행.",
  coordinationOfPromotionalActivities:
    "인쇄물, 다이렉트 메일 및 지역 광고를 포함한 홍보 활동 조정.",
  evaluationAndOptimization:
    "디지털 플랫폼 전반에서 광고 캠페인 평가 및 최적화.",
  creativeDevelopment:
    "ROI를 극대화하기 위한 크리에이티브 개발, 타겟팅 개선 및 성능 모니터링.",
  tailoredServices:
    "특정 요구 사항 및 목표를 해결하기 위한 맞춤형 서비스.",
  collaborationWithOurTeam:
    "고객의 고유한 요구 사항을 충족하는 맞춤형 솔루션을 개발하기 위한 당사 팀과의 협업.",
  serviceGetStarted: "시작하기",
  keyFeatures: "주요 기능",
  dataEnrichment: "데이터 보강",
  dataCleansing: "데이터 정제",
  customListGeneration: "맞춤 목록 생성",
  serviceOfferings: "서비스 제공 내용",
  introDataPreparation:
    "당사의 데이터 준비 서비스는 영업 데이터 관리를 최적화하기 위한 포괄적인 솔루션을 제공합니다. 이 서비스는...",
  introSalesAssitant:
    "영업 지원 서비스는 일반적인 관리 지원을 넘어, 영업 프로세스에 필수적인 작업에 특별히 중점을 둡니다. 이 서비스는...",
  introAppointmentSetting:
    "이 서비스는 제공된 정보를 기반으로 고객을 타겟 고객과 연결하는 개인화되고 실용적인 접근 방식을 포함합니다. 이 서비스는...",
  introOtherService:
    '고객이 고유한 요구 사항에 대한 세부 정보를 제출하여 맞춤 서비스를 요청할 수 있는 "기타" 서비스는...',
  questionCommonPagePriorityLevelTitle:
    "이 작업의 우선순위 수준은 무엇인가요?",
  questionCommonPagePriorityLevelDesc:
    "작업 우선순위를 명시하면 고객의 요구 사항을 신속하게 처리하는 데 도움이 됩니다. 제출 후에도 변경할 수 있습니다.",
  questionCommonPageTimelineTitle:
    "구독 기간 또는 타임라인에 대해 생각해 보셨나요?",
  questionCommonPageTimelineDesc:
    "원하는 기간과 시작 예정일을 알려주세요.",
  questionCommonPageServiceRequestTitle:
    "시작할 준비가 되셨나요? 먼저, 애플리케이션에 고유한 이름을 지정하세요",
  questionCommonPageServiceRequestDesc:
    "이 이름을 사용하여 대시보드에서 진행 상황을 추적하고 업데이트해 드립니다.",
  questionCommonPageServiceDurationTitle:
    "서비스 기간은 얼마나 되나요?",
  quesitonCommonPageInvestmentBudget:
    "비즈니스 개발 및 프로젝트에 대한 투자 예산이 월 HKD 12000을 초과하나요?",
  questionCommonPageHearAboutUs: "어디서 저희에 대해 들으셨나요?",
  questionCommonPageUploadTitle:
    "데이터 보강 또는 데이터 정제를 위해 Excel/CSV 파일을 여기에 업로드하세요",
  questionCommonPageUploadDesc:
    "맞춤 목록 생성을 선택한 경우 업로드하지 않고 건너뛰거나 '다음'을 클릭할 수 있습니다",
  questionDataPreparationPageInterestedDataOptimizationTitle:
    "데이터 최적화를 위해 어떤 서비스에 관심이 있으신가요?",
  questionDataPreparationPageInterestedDataOptimizationDesc:
    "데이터 보강 또는 데이터 정제를 선택하는 경우 다음 단계에서 CSV 파일을 첨부해야 합니다",
  questionDataPreparationPageDataAttributesTitle:
    "파일에 통합하려는 특정 데이터 속성을 선택하세요 (해당하는 경우)",
  questionDataPreparationPageDataAttributesDesc: "하나 이상 선택하세요",
  questionDataPreparationPageNumberOfLeadsTitle:
    "비즈니스를 위해 얼마나 많은 리드를 생성하거나 확보하고 싶으신가요?",
  questionDataPreparationPageNumberOfLeadsDesc:
    "고객을 위한 서비스를 맞춤화하기 위해 수량 또는 범위를 지정하세요",
  website_url: "웹사이트 URL",
  contact_first_name: "연락처 이름",
  contact_last_name: "연락처 성",
  contact_title: "연락처 직책",
  contact_location: "연락처 위치",
  contact_work_email: "연락처 회사 이메일",
  contact_personal_email: "연락처 개인 이메일",
  contact_work_phone: "연락처 회사 전화",
  contact_personal_phone: "연락처 개인 전화",
  company_size: "회사 규모",
  company_industry: "회사 산업",
  company_location: "회사 위치",
  company_founded_year: "회사 설립 연도",
  company_keywords: "회사 키워드",
  company_ranking_in_global: "회사 글로벌 순위",
  company_financial_status: "회사 재무 상태",
  company_office_address: "회사 사무실 주소",
  website_total_visit: "웹사이트 총 방문 수",
  company_funding_status: "회사 자금 조달 상태",
  slugServiceName: "서비스 이름",
  slugServiceDesc: "서비스 설명",
  errEnterServiceName: "서비스 이름을 입력하세요",
  errEnterDescription: "서비스 설명을 입력하세요",
  errSelectAService: "서비스를 선택하세요",
  errSelectSpecificDataAttributes: "특정 데이터 속성을 선택하세요",
  errInputTheQuantity: "수량을 입력하세요",
  errSelectPriorityLevel: "우선순위 수준을 선택하세요",
  errSelectTimeline: "타임라인을 선택하세요",
  errInputContent: "내용을 입력하세요",
  errInvestmentBudget: "예 또는 아니오를 선택하세요",
  errServiceDuration: "서비스 기간을 선택하세요",
  errHearAboutUs: "내용을 선택하세요",
  placeHolderEnterServiceName: "서비스 이름 입력",
  placeHolderEnterServiceDescription: "서비스 설명 입력",
  placeHolderEnterListGeneration: "목록 생성 입력",
  placeHolder150TO250: "150 - 250",
  Submit: "제출",
  serviceDownload: "다운로드",
  serviceExample: "예시",
  forYourReference: "참고용",
  yourFileNeedsToInclude:
    "파일에는 최소한 웹사이트 또는 회사 이름이 포함되어야 합니다",
  includeAll: "모두 포함",
  serviceNext: "다음",
  serviceBack: "뒤로",
  data_enrichment: "데이터 보강",
  data_cleansing: "데이터 정제",
  custom_list_generation: "맞춤 목록 생성",
  job_title: "직책",
  timeline_within_one_weeks: "1주 이내 타임라인",
  timeline_one_to_two_weeks: "1~2주 타임라인",
  timeline_two_to_four_weeks: "2~4주 타임라인",
  timeline_recurring: "반복 타임라인",
  timeline_custom_range: "맞춤 기간 타임라인",
  hear_about_us_social_media: "소셜 미디어",
  hear_about_us_google: "Google",
  hear_about_us_online_article: "온라인 기사",
  hear_about_us_webinar: "웨비나",
  hear_about_us_referral: "추천",
  hear_about_us_custom_input: "기타",
  duration_last_than_one_month: "1개월 미만",
  duration_one_to_three_months: "1~3개월",
  duration_over_three_months: "3개월 이상",
  duration_decide_later: "나중에 결정",
  yes: "예",
  no: "아니오",
  byCancelingYouCanEnsureThatNoTasksWillBeClosed:
    "취소하면 어떤 작업도 종료되지 않습니다",
  areYouSureYouWantToCloseThisTask: "이 작업을 종료하시겠습니까?",
  onceTheTaskIsClosed:
    "작업이 종료되면 되돌릴 수 없으며 다시 시작할 수 없습니다",
  Close: "종료",
  ourTeamIsWorkingOnThisTask: "저희 팀이 이 작업을 진행 중입니다",
  pleaseProviceYourReasonForThisAction:
    "이 작업에 대한 이유를 제공해주세요",
  sendRequest: "요청 보내기",
  OK: "확인",
  areYouSureYouWantToDelete: "삭제하시겠습니까?",
  proceedingWithDeletionWillResultInPermanentRemovalOfTheFile:
    "삭제를 진행하면 파일이 영구적으로 제거됩니다.",
  byCancelYouEnsureThatNoFileWillBeDeleted:
    "취소하면 어떤 파일도 삭제되지 않습니다",
  areYouSureYouWantToDeleteThis: "이것을 삭제하시겠습니까?",
  serviceMessage: "메시지",
  serviceFile: "파일",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisMessage:
    "삭제를 진행하면 이 메시지가 영구적으로 제거됩니다.",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisFile:
    "삭제를 진행하면 이 파일이 영구적으로 제거됩니다.",
  youEnsureThatNoMessagesWillBeDeleted:
    "취소하면 메시지가 삭제되지 않습니다",
  youEnsureThatNoFilessWillBeDeleted:
    "취소하면 파일이 삭제되지 않습니다",
  serviceDeleteFail: "삭제 실패",
  enterYourReason: "이유를 입력하세요",
  seriveStartDate: "시작일",
  serviceEndDate: "종료일",
  yourRequestHasBeenSent: "요청이 전송되었습니다",
  sendUsYourFeedback: "피드백을 보내주세요",
  weAreConstantlyImproving:
    "저희는 끊임없이 발전하고 있습니다! 피드백을 공유하여 저희 플랫폼의 미래를 만들어 주세요.",
  describeYourExperienceHere: "여기에 경험을 설명해 주세요...",
  additionallyYouCanAttachAnyScreenshots:
    "또한, 더 자세한 내용을 제공하기 위해 스크린샷이나 파일을 첨부할 수 있습니다.",
  sendFeedback: "피드백 보내기",
  serviceResume: "재개",
  yourRequestHasBeenResumed: "요청이 재개되었습니다",
  yourRequestIsCurrentlyPaused: "요청이 현재 일시 중지되었습니다",
  serviceEdited: "수정됨",
  theFileSizeCannotExceed50M: "파일 크기는 50M를 초과할 수 없습니다",
};